import { render } from "./UserDashboardInner.vue?vue&type=template&id=5b3b20cb"
import script from "./UserDashboardInner.vue?vue&type=script&lang=js"
export * from "./UserDashboardInner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__